import { defineComponent, h, PropType, VNode } from 'vue';
import { coming_soon } from '@components/icons';
import { show_export_modal } from '../../input_output';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import export_svg from '../../../assets/img/SVG_icons/Right/import-export/export.svg';
import export_svg_yellow from '../../../assets/img/SVG_icons/Right/import-export/export_bold.svg';
import { img } from '@phi/components';
import { IAuthentication } from '@phi/authentication/frontend';
import ExportTooltip from './ExportTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        auth: { required: true, type: Object as PropType<IAuthentication> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Export Model';
        },

        disabled(): boolean {
            return !this.state.loaded || this.state.editing_reference_sketches;
        },

        image(): VNode {
            if (!this.state.loaded)
                return coming_soon(this.alt);
            else if (this.state.is_demo)
                return img(export_svg_yellow, this.alt);
            else
                return img(export_svg, this.alt);
        },
    },

    methods: {
        onClick() {
            if (this.state.is_demo)
                this.auth.show_must_login_modal();
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else if (this.disabled)
                return;
            else
                show_export_modal();
        }
    },

    render() {
        return h(BarButton, {
            id: 'export-button',
            disabled: this.disabled,
            tippy: 'right',
            onClick: this.onClick,
            selected: this.state.tut_stage === 12,
            help: 'export_model',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.image,
            tooltip: ExportTooltip,
        });
    },
});
